import React from 'react';
import { Notification } from '@telus-uds/components-web';
import { ModuleFederationRuntimePlugin as FederationRuntimePlugin } from '@module-federation/enhanced/runtime';

/**
 * Module Federation runtime fallback.
 *
 * `errorLoadRemote` fires when a remote entry can't be resolved at all — a CDN
 * failure, a network blip, or a module that simply isn't exposed by the bundle
 * deployed to this environment. Whatever it returns is rendered in place of the
 * remote, and it runs *before* generateMfePage's own error handling, so it
 * owns the user-facing state in that case.
 *
 * It must therefore return a component that renders something. Returning
 * `console.error(...)` directly yields `undefined`, which React renders as
 * nothing — leaving a silently blank page that is indistinguishable from a
 * broken route.
 *
 * Lives in its own module (rather than beside `init()` in initMfes)
 * so it can be unit-tested without triggering federation initialisation.
 */
export const RemoteUnavailable = () => (
  <Notification variant={{ style: 'error' }}>
    This section isn’t available right now.
  </Notification>
);

export const fallbackPlugin: () => FederationRuntimePlugin = () => {
  return {
    name: 'fallback-plugin',
    errorLoadRemote(err: any) {
      // eslint-disable-next-line no-console
      console.error('One or more MFE components failed to load.', err);
      return { default: RemoteUnavailable };
    },
  };
};
